import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const COOKIE_VERSAO = 'versao_app'
const COOKIE_FORCADA = 'versao_app_forcada'
// Cópia exata do versao_app_forcada que este código já conferiu com o banco
const COOKIE_CONFIRMADA = 'versao_app_forcada_confirmada'
const VERSOES_VALIDAS = ['monolito', 'beta', 'hml']
const EXPIRACAO_VERSAO = '30d'
const EXPIRACAO_FORCADA = '7d'
// Base ainda desconhecida: a troca via URL acontece no carregamento, antes de qualquer resposta da API; o valor
// do banco é gravado como base na primeira resposta (processaVersaoAppResposta)
const BASE_PENDENTE = 'pendente'

let versaoPendente = null

// Cookie versao_app_forcada guarda 'versao|base', onde base é o valor que o
// banco tinha na hora da troca manual — se o banco mudar depois (equipe agiu
// via Areadev), o override é descartado e o banco volta a valer. A base nunca
// vem do cookie versao_app: ele pode não existir ou estar diferente do banco
// (primeiro acesso, depois de ?versao_app=auto, cookie antigo), e aí a primeira
// resposta da API descartava o override — "coloco hml e volta para beta do nada"
// (2026-09-14). Sem override anterior a base fica pendente até a primeira resposta.
//
// Bundles publicados antes dessa correção (produção inteira, módulos não
// republicados) ainda gravam a base a partir do cookie versao_app. Por isso só
// vale como base conferida o override que bate com COOKIE_CONFIRMADA; qualquer
// outro é tratado como pendente e recebe o valor do banco, em vez de ser descartado.
const pegaOverride = () => {
    const bruto = Vue.$cookies.get(COOKIE_FORCADA)
    if (!bruto) {
        return null
    }
    const partes = String(bruto).split('|')
    if (
        partes.length !== 2
        ||
        !VERSOES_VALIDAS.includes(partes[0])
        ||
        !(VERSOES_VALIDAS.includes(partes[1]) || partes[1] === BASE_PENDENTE)
    ) {
        removeOverride()
        return null
    }
    return {
        versao: partes[0],
        base: partes[1],
        confirmada: partes[1] !== BASE_PENDENTE && Vue.$cookies.get(COOKIE_CONFIRMADA) === String(bruto)
    }
}

const gravaOverride = (versao, base, confirmada) => {
    const valor = versao + '|' + base
    Vue.$cookies.set(COOKIE_FORCADA, valor, EXPIRACAO_FORCADA)
    if (confirmada) {
        Vue.$cookies.set(COOKIE_CONFIRMADA, valor, EXPIRACAO_FORCADA)
    } else {
        Vue.$cookies.remove(COOKIE_CONFIRMADA)
    }
}

const removeOverride = () => {
    Vue.$cookies.remove(COOKIE_FORCADA)
    Vue.$cookies.remove(COOKIE_CONFIRMADA)
}

export const aplicaVersaoAppDaUrl = () => {
    const url = new URL(window.location.href)
    const versao = url.searchParams.get(COOKIE_VERSAO)
    if (versao === null) {
        return false
    }
    url.searchParams.delete(COOKIE_VERSAO)
    window.history.replaceState(null, '', url.pathname + url.search + url.hash)
    if (versao === 'auto') {
        removeOverride()
        Vue.$cookies.remove(COOKIE_VERSAO)
        window.location.reload()
        return true
    }
    if (!VERSOES_VALIDAS.includes(versao)) {
        return false
    }
    // Troca em cima de um override conferido mantém a base dele; sem override, ou com base não conferida, fica pendente
    const override = pegaOverride()
    if (override && override.confirmada) {
        gravaOverride(versao, override.base, true)
    } else {
        gravaOverride(versao, BASE_PENDENTE, false)
    }
    Vue.$cookies.set(COOKIE_VERSAO, versao, EXPIRACAO_VERSAO)
    window.location.reload()
    return true
}

export const processaVersaoAppResposta = (headers) => {
    const versaoBanco = headers && headers['x-versao-app']
    if (!versaoBanco || !VERSOES_VALIDAS.includes(versaoBanco)) {
        return
    }
    const override = pegaOverride()
    const cookieAtual = Vue.$cookies.get(COOKIE_VERSAO)
    if (override && !override.confirmada) {
        // Primeira resposta depois da troca (via URL aqui ou gravada por bundle antigo): o valor do banco vira a base
        override.base = versaoBanco
        override.confirmada = true
        gravaOverride(override.versao, versaoBanco, true)
    }
    if (override) {
        if (versaoBanco === override.base) {
            if (cookieAtual !== override.versao) {
                versaoPendente = override.versao
            }
            return
        }
        removeOverride()
    }
    if (versaoBanco !== cookieAtual) {
        versaoPendente = versaoBanco
    }
}

// A troca só é aplicada na navegação de rota (destinoHref já resolvido pelo
// router), nunca no meio de uma tela — evita perder formulário em edição.
export const aplicaVersaoAppPendente = (destinoHref) => {
    if (!versaoPendente) {
        return false
    }
    Vue.$cookies.set(COOKIE_VERSAO, versaoPendente, EXPIRACAO_VERSAO)
    versaoPendente = null
    window.location.href = destinoHref
    return true
}
